import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportInputsService {
  private readonly isEditModeValues: Map<string, boolean> = new Map();
  private readonly isEditModeValueSubject = new BehaviorSubject<
    Map<string, boolean>
  >(this.isEditModeValues);

  private readonly markAsNAValueSubject = new Subject<{
    [id: string]: string;
  }>();

  private readonly undoSelfInspectionSubject = new Subject<string>();

  private readonly uploadFilesSubject = new Subject<{ [id: string]: Event }>();

  markAsNAValue$ = this.markAsNAValueSubject.asObservable();
  undoSelfInspection$ = this.undoSelfInspectionSubject.asObservable();
  uploadFiles$ = this.uploadFilesSubject.asObservable();
  isEditModeValue$ = this.isEditModeValueSubject.asObservable();

  setIsEditModeValue(id: string, value: boolean): void {
    this.isEditModeValues.set(id, value);
    this.isEditModeValueSubject.next(new Map(this.isEditModeValues));
  }

  setMarkAsNAValue(id: string, comment: string): void {
    this.markAsNAValueSubject.next({ [id]: comment });
  }

  setUndoSelfInspection(id: string) {
    this.undoSelfInspectionSubject.next(id);
  }

  setUploadFiles(id: string, $event: Event) {
    this.uploadFilesSubject.next({ [id]: $event });
  }
}
